/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const common = {
    black: 'rgba(0,0,0,0.87)',
    white: '#FFFFFF',
    offWhite: '#FAFAFA',
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const aqua = {
    50: '#dff7fb',
    100: '#b0eaf4',
    200: '#7cddec',
    300: '#44cee4',
    400: '#05c3dd',
    500: '#00bad7',
    600: '#00aac4',
    700: '#0095a9',
    800: '#008191',
    900: '#005e65',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.black,
        700: common.black,
        800: common.white,
        900: common.white,
    },
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const blue = {
    50: '#E2F1FC',
    100: '#B9DCFA',
    200: '#8CC7F7',
    300: '#5EB1F3',
    400: '#39A0F1',
    500: '#0691EF',
    600: '#0483E1',
    700: '#0072CE',
    800: '#0060BC',
    900: '#00439D',
    A100: '#C3D7EE',
    A200: '#9DBFE7',
    A400: '#6095DD',
    A700: '#4366B7',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.black,
        700: common.white,
        800: common.white,
        900: common.white,
        A100: common.black,
        A200: common.black,
        A400: common.black,
        A700: common.white,
    },
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const gray = {
    50: '#F9F9F6',
    100: '#F2F2EF',
    200: '#E9E9E6',
    300: '#D9D9D6',
    400: '#B5B5B2',
    500: '#959593',
    600: '#6D6D6A',
    700: '#595957',
    800: '#3B3B39',
    900: '#1B1B19',
    A800: '#333',
    A900: '#212121',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.white,
        700: common.white,
        800: common.white,
        900: common.white,
        A800: common.white,
        A900: common.white,
    },
};
const grey = gray;

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const green = {
    50: '#edf8e9',
    100: '#d3edc8',
    200: '#b7e1a5',
    300: '#99d481',
    400: '#82cb65',
    500: '#6cc24a',
    600: '#5eb242',
    700: '#4a9e38',
    800: '#368a2e',
    900: '#07671c',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.black,
        700: common.black,
        800: common.black,
        900: common.white,
    },
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const orange = {
    50: '#fff3e0',
    100: '#fee0b3',
    200: '#fecc81',
    300: '#fdb74f',
    400: '#fda72a',
    500: '#fd980a',
    600: '#f98c09',
    700: '#f27d07',
    800: '#ec6d06',
    900: '#e35305',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.black,
        700: common.black,
        800: common.black,
        900: common.black,
    },
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const purple = {
    50: '#f0e6fb',
    100: '#d8c1f4',
    200: '#be98ee',
    300: '#a36be8',
    400: '#8e46e3',
    500: '#7718dc',
    600: '#6c11d6',
    700: '#5d00ce',
    800: '#4d00c8',
    900: '#2f00c0',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.white,
        500: common.white,
        600: common.white,
        700: common.white,
        800: common.white,
        900: common.white,
    },
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const red = {
    50: '#FFEAEE',
    100: '#FFCBD2',
    200: '#F99698',
    300: '#F26C6F',
    400: '#FE444A',
    500: '#FF2A2B',
    600: '#F51B2C',
    700: '#E30526',
    800: '#D6001E',
    900: '#C8000F',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.black,
        700: common.white,
        800: common.white,
        900: common.white,
    },
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const yellow = {
    50: '#fdf8e2',
    100: '#f9ebb6',
    200: '#f6df87',
    300: '#f4d459',
    400: '#f2c93a',
    500: '#f0c029',
    600: '#f0b323',
    700: '#efa11e',
    800: '#ef911a',
    900: '#ed7514',
    contrast: {
        50: common.black,
        100: common.black,
        200: common.black,
        300: common.black,
        400: common.black,
        500: common.black,
        600: common.black,
        700: common.black,
        800: common.black,
        900: common.black,
    },
};

/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const setGreyAliases = (palette) => {
    palette.darkestGrey = palette.darkestGray;
    palette.contrast.darkestGrey = palette.contrast.darkestGray;
    palette.darkGrey = palette.darkGray;
    palette.contrast.darkGrey = palette.contrast.darkGray;
    palette.grey = palette.gray;
    palette.contrast.grey = palette.contrast.gray;
    palette.lightGrey = palette.lightGray;
    palette.contrast.lightGrey = palette.contrast.lightGray;
    palette.lightestGrey = palette.lightestGray;
    palette.contrast.lightestGrey = palette.contrast.lightestGray;
};

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/** Palette of colors for light theme */
const darkThemePalette = {
    background: gray.A900,
    surface: gray.A800,
    // Primary colors
    blue: blue[300],
    darkBlue: blue[500],
    lightBlue: blue[100],
    lightestBlue: blue[50],
    // Neutral colors
    black: common.black,
    darkestGray: gray[700],
    darkGray: gray[500],
    gray: gray[300],
    lightGray: gray[100],
    offWhite: common.offWhite,
    white: common.white,
    // Grey aliases
    darkestGrey: '',
    darkGrey: '',
    grey: '',
    lightGrey: '',
    // Supporting colors
    darkRed: red[500],
    red: red[300],
    lightRed: red[100],
    lightestRed: red[50],
    darkGreen: green[500],
    green: green[300],
    lightGreen: green[100],
    yellow: yellow[300],
    lightYellow: yellow[100],
    orange: orange[300],
    purple: purple[300],
    darkAqua: aqua[600],
    aqua: aqua[400],
    lightAqua: aqua[100],
    // Aliases
    primary: '',
    secondary: '',
    warn: '',
    contrast: {
        background: gray.contrast.A900,
        surface: gray.contrast.A800,
        // Primary colors
        blue: blue.contrast[300],
        darkBlue: blue.contrast[500],
        lightBlue: blue.contrast[100],
        lightestBlue: blue.contrast[50],
        // Neutral colors
        black: common.white,
        darkestGray: gray.contrast[700],
        darkGray: gray.contrast[500],
        gray: gray.contrast[300],
        lightGray: gray.contrast[100],
        offWhite: common.black,
        white: common.black,
        // Grey aliases
        darkestGrey: '',
        darkGrey: '',
        grey: '',
        lightGrey: '',
        // Supporting colors
        darkRed: red.contrast[500],
        red: red.contrast[300],
        lightRed: red.contrast[100],
        lightestRed: red.contrast[50],
        darkGreen: green.contrast[500],
        green: green.contrast[300],
        lightGreen: green.contrast[100],
        yellow: yellow.contrast[300],
        lightYellow: yellow.contrast[100],
        orange: orange.contrast[300],
        purple: purple.contrast[300],
        darkAqua: aqua.contrast[600],
        aqua: aqua.contrast[400],
        lightAqua: aqua.contrast[100],
        // Aliases
        primary: blue.contrast[300],
        secondary: blue.contrast[300],
        warn: red.contrast[300],
    },
};
darkThemePalette.primary = darkThemePalette.blue;
darkThemePalette.secondary = darkThemePalette.blue;
darkThemePalette.warn = darkThemePalette.red;
setGreyAliases(darkThemePalette);

/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/** Palette of colors for light theme */
const lightThemePalette = {
    background: common.offWhite,
    surface: common.white,
    // Primary colors
    blue: blue[700],
    darkBlue: blue[900],
    lightBlue: blue[300],
    lightestBlue: blue[50],
    // Neutral colors
    black: common.black,
    darkestGray: gray[800],
    darkGray: gray[700],
    gray: gray[500],
    lightGray: gray[300],
    lightestGray: gray[100],
    offWhite: common.offWhite,
    white: common.white,
    // Grey aliases
    darkestGrey: '',
    darkGrey: '',
    grey: '',
    lightGrey: '',
    lightestGrey: '',
    // Supporting colors
    /** @deprecated use blue 200 instead. removing in 3.0 */
    blueGray: blue.A200,
    darkRed: red[900],
    red: red[700],
    lightRed: red[200],
    lightestRed: red[50],
    darkGreen: green[900],
    green: green[700],
    lightGreen: green[100],
    yellow: yellow[600],
    lightYellow: yellow[100],
    orange: orange[700],
    purple: purple[400],
    // Aliases
    primary: '',
    secondary: '',
    warn: '',
    contrast: {
        background: common.black,
        surface: common.black,
        // Primary colors
        blue: blue.contrast[700],
        darkBlue: blue.contrast[900],
        lightBlue: blue.contrast[300],
        lightestBlue: blue.contrast[50],
        // Neutral colors
        black: common.white,
        darkestGray: gray.contrast[800],
        darkGray: gray.contrast[700],
        gray: gray.contrast[500],
        lightGray: gray.contrast[300],
        lightestGray: gray.contrast[100],
        offWhite: common.black,
        white: common.black,
        // Grey aliases
        darkestGrey: '',
        darkGrey: '',
        grey: '',
        lightGrey: '',
        lightestGrey: '',
        // Supporting colors
        /** @deprecated use blue 200 contrast instead. removing in 3.0 */
        blueGray: blue.contrast.A200,
        darkRed: red.contrast[900],
        red: red.contrast[700],
        lightRed: red.contrast[200],
        lightestRed: red.contrast[50],
        darkGreen: green.contrast[900],
        green: green.contrast[700],
        lightGreen: green.contrast[100],
        yellow: yellow.contrast[600],
        lightYellow: yellow.contrast[100],
        orange: orange.contrast[700],
        purple: purple.contrast[400],
        // Aliases
        primary: blue.contrast[700],
        secondary: gray.contrast[700],
        warn: red.contrast[700],
    },
};
lightThemePalette.primary = lightThemePalette.blue;
lightThemePalette.secondary = lightThemePalette.darkGray;
lightThemePalette.warn = lightThemePalette.red;
setGreyAliases(lightThemePalette);

export { aqua, blue, common, darkThemePalette, gray, green, grey, lightThemePalette, orange, purple, red, yellow };
